var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.filters.length)?_c('div',_vm._l((_vm.filters),function(ref,i){
var filterComponent = ref.filterComponent;
var props = ref.props;
var on = ref.on;
var handlers = ref.handlers;
return _c('v-list-item',{key:i},[_c('v-list-item-content',{staticClass:"pa-2"},[_c(filterComponent,_vm._g(_vm._b({tag:"component"},'component',props,false),Object.assign({}, on, handlers)))],1)],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }